import { t } from 'i18next'
import { Item } from '../../../../../store/types'
import i18n from '../../../../../config/i18n'
import Carousel from '../../schedule/carousel/CustomCarousel'
import { environment } from '../../../../../enviroments/enviroment'

const translationBase = 'components.infoSidebar.worklog.carousel.dailyRecord'
const urlBase = `${environment.publicUrl}/assets/image/carousel/info/dailyRecord`

const LIGHT_PL_1 = `${urlBase}/dailyRecord-light-PL-1.png`
const LIGHT_PL_2 = `${urlBase}/dailyRecord-light-PL-2.png`
const LIGHT_PL_3 = `${urlBase}/dailyRecord-light-PL-3.png`

const DARK_PL_1 = `${urlBase}/dailyRecord-dark-PL-1.png`
const DARK_PL_2 = `${urlBase}/dailyRecord-dark-PL-2.png`
const DARK_PL_3 = `${urlBase}/dailyRecord-dark-PL-3.png`

const LIGHT_EN_1 = `${urlBase}/dailyRecord-light-EN-1.png`
const LIGHT_EN_2 = `${urlBase}/dailyRecord-light-EN-2.png`
const LIGHT_EN_3 = `${urlBase}/dailyRecord-light-EN-3.png`

const DARK_EN_1 = `${urlBase}/dailyRecord-dark-EN-1.png`
const DARK_EN_2 = `${urlBase}/dailyRecord-dark-EN-2.png`
const DARK_EN_3 = `${urlBase}/dailyRecord-dark-EN-3.png`

const WorklogCarousel = () => {
  const isPolish = i18n.language === 'pl'
  const items: Item[] = [
    {
      subtitle: t(`${translationBase}.details.subtitle`),
      description: t(`${translationBase}.details.description`),
      imageLight: isPolish ? LIGHT_PL_1 : LIGHT_EN_1,
      imageDark: isPolish ? DARK_PL_1 : DARK_EN_1,
      key: 'carousel-worklog-info-workRecord-1',
    },
    {
      subtitle: t(`${translationBase}.inserting.subtitle`),
      description: t(`${translationBase}.inserting.description`),
      imageLight: isPolish ? LIGHT_PL_2 : LIGHT_EN_2,
      imageDark: isPolish ? DARK_PL_2 : DARK_EN_2,
      key: 'carousel-worklog-info-workRecord-2',
    },
    {
      subtitle: t(`${translationBase}.yourHours.subtitle`),
      description: t(`${translationBase}.yourHours.description`),
      imageLight: isPolish ? LIGHT_PL_3 : LIGHT_EN_3,
      imageDark: isPolish ? DARK_PL_3 : DARK_EN_3,
      key: 'carousel-worklog-info-workRecord-3',
    }
  ]

  return <Carousel title={t(`${translationBase}.title`)} items={items} />
}

export default WorklogCarousel
